import { SimpleInput, SimpleInputProps } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

type PriceInput = Pick<
  SimpleInputProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required' | 'errorMessage' | 'value'
>;

export const PriceInput = forwardRef<HTMLInputElement, PriceInput>((props, ref) => (
  <SimpleInput ref={ref} size="sm" type="number" prefix="$" useSeparator {...props} />
));
